import BackOfficeApp from 'hb-react/backoffice/providers/App';
import InputLocation from 'hb-react/shared/components/DesignSystem/Inputs/InputLocation';
import { type InputLocationProps } from 'hb-react/shared/components/DesignSystem/Inputs/InputLocation/types';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

const InputLocationStandalone = (props: InputLocationProps) => {
  const { flagEvGeoboxSearch } = useFeatureFlag();

  if (flagEvGeoboxSearch) {
    return (
      <BackOfficeApp>
        <InputLocation {...props} />
      </BackOfficeApp>
    );
  }

  return <InputLocation {...props} />;
};

export default InputLocationStandalone;
